import { Projections } from "../geography";
import { Observable, PropertyChangedEventArgs } from "../events";
export class TileSystemBounds {
    static Intersection(bounds) {
        if (!bounds || bounds.length === 0) {
            return null;
        }
        const result = bounds[0].clone();
        for (let i = 1; i < bounds.length; i++) {
            result.intersectionInPlace(bounds[i]);
        }
        return result;
    }
    static Union(bounds) {
        if (!bounds || bounds.length === 0) {
            return null;
        }
        const result = bounds[0].clone();
        for (let i = 1; i < bounds.length; i++) {
            result.unionInPlace(bounds[i]);
        }
        return result;
    }
    constructor(p) {
        this._minLOD = TileSystemBounds.DefaultMinLOD;
        this._maxLOD = TileSystemBounds.DefaultMaxLOD;
        this._minLatitude = TileSystemBounds.DefaultMinLatitude;
        this._maxLatitude = TileSystemBounds.DefaultMaxLatitude;
        this._minLongitude = TileSystemBounds.DefaultMinLongitude;
        this._maxLongitude = TileSystemBounds.DefaultMaxLongitude;
        if (p) {
            Object.assign(this, p);
        }
    }
    get propertyChangedObservable() {
        if (!this._propertyChangedObservable) {
            this._propertyChangedObservable = new Observable();
        }
        return this._propertyChangedObservable;
    }
    unionInPlace(bounds) {
        if (bounds) {
            this.minLOD = Math.min(this.minLOD, bounds.minLOD);
            this.maxLOD = Math.max(this.maxLOD, bounds.maxLOD);
            this.minLatitude = Math.min(this.minLatitude, bounds.minLatitude);
            this.maxLatitude = Math.max(this.maxLatitude, bounds.maxLatitude);
            this.minLongitude = Math.min(this.minLongitude, bounds.minLongitude);
            this.maxLongitude = Math.max(this.maxLongitude, bounds.maxLongitude);
        }
    }
    copy(bounds) {
        if (bounds) {
            this.minLOD = bounds.minLOD;
            this.maxLOD = bounds.maxLOD;
            this.minLatitude = bounds.minLatitude;
            this.maxLatitude = bounds.maxLatitude;
            this.minLongitude = bounds.minLongitude;
            this.maxLongitude = bounds.maxLongitude;
        }
    }
    clone() {
        return new TileSystemBounds(this);
    }
    intersectionInPlace(bounds) {
        if (bounds) {
            this.minLOD = Math.max(this.minLOD, bounds.minLOD);
            this.maxLOD = Math.min(this.maxLOD, bounds.maxLOD);
            this.minLatitude = Math.max(this.minLatitude, bounds.minLatitude);
            this.maxLatitude = Math.min(this.maxLatitude, bounds.maxLatitude);
            this.minLongitude = Math.max(this.minLongitude, bounds.minLongitude);
            this.maxLongitude = Math.min(this.maxLongitude, bounds.maxLongitude);
        }
    }
    get minLOD() {
        return this._minLOD;
    }
    set minLOD(v) {
        if (this._minLOD !== v) {
            const old = this._minLOD;
            this._minLOD = v;
            this._propertyChangedObservable?.notifyObservers(new PropertyChangedEventArgs(this, old, v, "minLOD"), -1, this, this);
        }
    }
    get maxLOD() {
        return this._maxLOD;
    }
    set maxLOD(v) {
        if (this._maxLOD !== v) {
            const old = this._maxLOD;
            this._maxLOD = v;
            this._propertyChangedObservable?.notifyObservers(new PropertyChangedEventArgs(this, old, v, "maxLOD"), -1, this, this);
        }
    }
    get minLatitude() {
        return this._minLatitude;
    }
    set minLatitude(v) {
        if (this._minLatitude !== v) {
            const old = this._minLatitude;
            this._minLatitude = v;
            this._propertyChangedObservable?.notifyObservers(new PropertyChangedEventArgs(this, old, v, "minLatitude"), -1, this, this);
        }
    }
    get maxLatitude() {
        return this._maxLatitude;
    }
    set maxLatitude(v) {
        if (this._maxLatitude !== v) {
            const old = this._maxLatitude;
            this._maxLatitude = v;
            this._propertyChangedObservable?.notifyObservers(new PropertyChangedEventArgs(this, old, v, "maxLatitude"), -1, this, this);
        }
    }
    get minLongitude() {
        return this._minLongitude;
    }
    set minLongitude(v) {
        if (this._minLongitude !== v) {
            const old = this._minLongitude;
            this._minLongitude = v;
            this._propertyChangedObservable?.notifyObservers(new PropertyChangedEventArgs(this, old, v, "minLongitude"), -1, this, this);
        }
    }
    get maxLongitude() {
        return this._maxLongitude;
    }
    set maxLongitude(v) {
        if (this._maxLongitude !== v) {
            const old = this._maxLongitude;
            this._maxLongitude = v;
            this._propertyChangedObservable?.notifyObservers(new PropertyChangedEventArgs(this, old, v, "maxLongitude"), -1, this, this);
        }
    }
}
TileSystemBounds.DefaultLOD = 0;
TileSystemBounds.DefaultMinLOD = 0;
TileSystemBounds.DefaultMaxLOD = 23;
TileSystemBounds.DefaultMinLatitude = Projections.WebMercatorMinLatitude;
TileSystemBounds.DefaultMaxLatitude = Projections.WebMercatorMaxLatitude;
TileSystemBounds.DefaultMinLongitude = -180;
TileSystemBounds.DefaultMaxLongitude = 180;
TileSystemBounds.Shared = new TileSystemBounds();
//# sourceMappingURL=tiles.system.js.map